import { useSelector } from 'react-redux'

import { getAuthSelectedTimeZone } from '../../data/auth/authSelectors'

export const getBrowserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'America/Los_Angeles'

export const useTimeZone = (): string => {
  const selectedTimeZone = useSelector(getAuthSelectedTimeZone)
  return selectedTimeZone ?? getBrowserTimeZone()
}
